export function getPaymentInfo(locationState) {
  if (locationState) return locationState;

  try {
    return JSON.parse(sessionStorage.getItem("paymentInfo") || "{}") || {};
  } catch (error) {
    sessionStorage.removeItem("paymentInfo");
    return {};
  }
}
